<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="860px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div id="projectQuotaList">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContract"
        style="margin: 10px 0"
        >打印
      </el-button>
      <div ref="projectQuotaList" id="projectQuotaList">
        <div
          style="
            border-right: 1px solid rgb(222, 222, 222, 0.6);
            border-left: 1px solid rgb(222, 222, 222, 0.6);
          "
        >
          <div
            style="
              border: 1px solid rgb(222, 222, 222, 0.6);
              text-align: center;
              font-size: 30px;
              padding: 30px 0 20px;
            "
          >
            {{ printData.contractListTitle }}
          </div>
          <!-- <div style="text-align: center;font-size: 20px">合同审签表</div> -->
          <!-- <div>
					<div
						style="display: inline-block;width: 100px; text-align: right"
					>
						经办部门:
					</div>
					<div
						contenteditable="true"
						style="display: inline-block;width: calc(100% - 240px)"
					>
						{{ printData.handleDeptName }}
					</div>
					<div
						contenteditable="true"
						style="display: inline-block;text-align: right"
					>
						{{ printData.signDate }}
					</div>
				</div> -->
          <div>
            <div
              style="
                border-bottom: 1px solid rgb(222, 222, 222, 0.6);
                display: flex;
                min-height: 40px;
              "
            >
              <div
                style="
                  width: 50%;
                  border-right: 1px solid rgb(222, 222, 222, 0.6);
                  padding: 4px;
                  display: flex;
                  align-items: center;
                "
              >
                项目名称：{{ printData.projectName }}
              </div>
              <!-- <div
							contenteditable="true"
							style="flex: 1;padding: 4px;display: flex;align-items: center;"
						>
							{{ printData.contractName }}
						</div> -->
              <div
                contenteditable="true"
                style="
                  flex: 1;
                  display: flex;
                  align-items: center;
                  padding: 4px;
                "
              >
                合同编号：{{ printData.serialNumber }}
              </div>
              <!-- <div
							contenteditable="true"
							style="flex: 1;padding: 4px;display: flex;align-items: center;"
						>
							{{ printData.contractSerialNumber }}
						</div> -->
            </div>
            <div style="display: flex; min-height: 40px">
              <div
                style="
                  width: 50%;
                  border-right: 1px solid rgb(222, 222, 222, 0.6);
                  display: flex;
                  align-items: center;
                  padding: 4px;
                "
              >
                施工部位：{{ printData.constructionSite }}
              </div>
              <!-- <div
							contenteditable="true"
							style="flex: 1;padding: 4px;display: flex;align-items: center;"
						>
							{{ printData.contractName }}
						</div> -->
              <div
                contenteditable="true"
                style="
                  flex: 1;
                  display: flex;
                  align-items: center;
                  padding: 4px;
                "
              >
                施工单位：{{ printData.partyB }}
              </div>
            </div>
          </div>
          <div style="border: 1px solid rgb(0, 0, 0, 0.6)">
            <div
              style="
                border-bottom: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                min-height: 40px;
              "
            >
              <div
                contenteditable="true"
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                细目号
              </div>

              <div
                contenteditable="true"
                style="
                  width: 100px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                细目名称
              </div>
              <div
                style="
                  width: 40px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                单位
              </div>

              <div
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                合同数量
              </div>
              <div
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                裸税单价(元)
              </div>

              <div
                style="
                  width: 46px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                增值税税率(%)
              </div>
              <div
                style="
                  width: 50px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                税后综合单价(元)
              </div>

              <div
                style="
                  width: 76px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                裸税合价(元)
              </div>
              <div
                style="
                  width: 76px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                税后合价(元)
              </div>

              <div
                style="
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                备注
              </div>
            </div>
            <div
              style="
                border-bottom: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                min-height: 40px;
                page-break-inside: avoid;
              "
              v-for="(item,index) in engineerItems"
              :key="item.subCategoryNo+index"
            >
              <div
                contenteditable="true"
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  word-break: break-all;
                "
              >
                {{ item.subCategoryNo }}
              </div>

              <div
                contenteditable="true"
                style="
                  width: 100px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                "
              >
                {{ item.subCategoryName }}
              </div>
              <div
                style="
                  width: 40px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ item.unit }}
              </div>

              <div
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ item.quantity }}
              </div>
              <div
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ item.bidPrice }}
              </div>

              <div
                style="
                  width: 46px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ item.taxRate }}
              </div>
              <div
                style="
                  width: 50px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ item.synthesizePriceAfterTax }}
              </div>

              <div
                style="
                  width: 76px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  word-break: break-all;
                "
              >
                {{ item.totalPurePrice }}
              </div>
              <div
                style="
                  width: 76px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  word-break: break-all;
                "
              >
                {{ item.totalPriceAfterTax }}
              </div>

              <div
                contenteditable="true"
                style="
                  flex: 1;
                  display: flex;
                  align-items: center;
                  word-break: break-all;
                "
              >
                {{ item.remarks }}
              </div>
            </div>
            <div style="display: flex; min-height: 40px">
              <div
                contenteditable="true"
                style="
                  width: 161px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                合计
              </div>
              <div
                style="
                  width: 40px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                元
              </div>

              <div
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              ></div>
              <div
                style="
                  width: 60px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              ></div>

              <div
                style="
                  width: 46px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              ></div>
              <div
                style="
                  width: 50px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              ></div>

              <div
                style="
                  width: 76px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 12px;
                  word-break: break-all;
                "
              >
                {{ printData.totalPurePrice }}
              </div>
              <div
                style="
                  width: 76px;
                  border-right: 1px solid rgb(0, 0, 0, 0.6);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 12px;
                  word-break: break-all;
                "
              >
                <!-- 1111111.89 -->
                {{ printData.totalPriceAfterTax }}
              </div>

              <div
                style="
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              ></div>
            </div>
          </div>
          <div
            style="
              border-left: 1px solid rgb(0, 0, 0, 0.6);
              border-right: 1px solid rgb(0, 0, 0, 0.6);
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 40px;
            "
            v-if="printData.others"
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              其他
            </div>
            <div
              contenteditable="true"
              style="
                display: inline-block;
                padding: 4px;
                width: calc(100% - 120px);
                display: flex;
                align-items: center;
              "
            >
              {{ printData.others }}
            </div>
          </div>
          <div
            style="
              display: flex;
              min-height: 40px;
              border: 1px solid rgb(0, 0, 0, 0.6);
              border-top: none;
            "
            v-if="printData.remarks"
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              备注
            </div>
            <div
              contenteditable="true"
              style="
                display: inline-block;
                padding: 4px;
                width: calc(100% - 120px);
                display: flex;
                align-items: center;
              "
            >
              {{ printData.remarks }}
            </div>
          </div>
        </div>
        <div height="20px">&nbsp;</div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="projectQuotaListContent"
          class="mainHtml"
          id="printprojectQuotaListContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "projectQuotaList",
  props: {
    printData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
    engineerItems: {
      type: Array,
      default: () => [],
    },
    // goodItems:{
    // 	type: Object,
    // },
  },
  data() {
    return {
      approveProcessList: [],
      projectQuotaListContent: null,
    };
  },
  // computed: {
  // 	printData() {
  // 		const filterApproveInfoList = this.printData.approveInfoList.filter(
  // 			(i) => i.isPrint
  // 		);
  // 		return {
  // 			...this.printData,
  // 			filterApproveInfoList,
  // 		};
  // 	},
  // },

  mounted() {
    this.$nextTick(() => {
      this.projectQuotaListContent = this.$refs.projectQuotaList.innerHTML;
      this.projectQuotaListContent =
        document.getElementById("projectQuotaList").innerHTML;
    });
  },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "projectQuotaListContent",
        this.$refs.projectQuotaList.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printprojectQuotaListContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
  },
};
</script>
<style lang="scss">
#projectQuotaList {
  // box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  // padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
